export const manifest = {
  screens: {
    scr_nalhtw: { name: "Revenue overview", route: "/" },
  },
}
